import React from "react"
import { Link } from "gatsby"
import Image from "gatsby-plugin-sanity-image"

import { ArrowButton } from "../ui/links"

export const BlogCard = ({ portalImage, title, slug, excerpt }) => {
  return (
    <Link to={`/blog/${slug && slug.current}`} className="grid gap-y-10">
      <div className="aspect-w-1 aspect-h-1 relative w-full">
        {portalImage && (
          <Image
            {...portalImage}
            className="w-full h-full absolute object-cover left-0 top-0"
          />
        )}
      </div>
      <div>
        <h4 className="font-display text-2xl mb-3">{title}</h4>
        <h6>{excerpt}</h6>
      </div>
      <ArrowButton arrowColor="text-marphonaGold">Read More</ArrowButton>
    </Link>
  )
}
